import { Responsive } from '@cian/ui-kit/responsive';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { HeaderLayout } from '../../../components/Header/Redesign';
import { AUD_MOBILE_REDESIGN_MAINPAGE_HEADER } from '../../../constants/experiments';
import { useEventBus } from '../../../hooks/useEventBus';
import { selectExperiments } from '../../../selectors/experiments';
import { IApplicationState } from '../../../types/redux';
import { getExperiment } from '../../../utils/experiments';
import { AuthenticationModalContainer } from '../../AuthenticationModalContainer';
import { DropdownContainer } from '../../DropdownContainer';
import { DropdownBackdropContainer } from '../../DropdownContainer/DropdownBackdropContainer';
import { HamburgerContainer } from '../../HamburgerContainer';
import { LogoContainer } from '../../LogoContainer';
import { NavBarContainer } from '../../NavBarContainer/Redesign';
import { UserRelatedContainer } from '../../UserRelatedContainer';

export const HeaderContainer: React.FC = () => {
  useEventBus();

  const noResize = useSelector((state: IApplicationState) => state.noResize);
  const buttonRef = React.useRef<HTMLButtonElement | null>(null);
  const navbarRef = React.useRef<HTMLDivElement | null>(null);

  const [isMainPage, setIsMainPage] = React.useState(false);

  React.useEffect(() => {
    setIsMainPage(window.location.pathname === '/');
  }, []);

  const experiments = useSelector(selectExperiments);
  const experimentGroup = getExperiment(experiments, AUD_MOBILE_REDESIGN_MAINPAGE_HEADER)?.group;

  const content = (
    <>
      {!noResize && (
        <Responsive phone tablet>
          <HamburgerContainer />
        </Responsive>
      )}
      <LogoContainer />
      <UserRelatedContainer />
      <AuthenticationModalContainer />
    </>
  );

  const navbar = noResize ? (
    <NavBarContainer navbarRef={navbarRef} />
  ) : (
    <Responsive desktop>
      <NavBarContainer navbarRef={navbarRef} />
    </Responsive>
  );

  return (
    <>
      <HeaderLayout
        noResize={noResize}
        content={content}
        navbar={navbar}
        isNeedDivider={!isMainPage || !['B', 'C'].includes(experimentGroup || '')}
      >
        <DropdownContainer menuRef={buttonRef} navbarRef={navbarRef} />
      </HeaderLayout>
      <DropdownBackdropContainer />
    </>
  );
};
